import { defineComponent } from 'vue';
import { hostPath } from '@utils/basePath';
import { appPort, jumpModuleApp, goToStudy, getUserId } from '@/widget/index';
import { getCoursePermission } from '@/api/video';
export default defineComponent({
    props: {
        item: {
            type: Object,
            default() {
                return {};
            }
        },
        size: {
            type: String,
            default: 'normal'
        },
        ios: {
            type: Boolean,
            default: false
        },
        showBorder: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            kw: this.$route.query.keyword
        };
    },
    methods: {
        toLearn(courseId, courseType) {
            let isApp = appPort();
            if (isApp) {
                goToStudy(courseType, courseId);
            }
            else {
                location.assign(`${hostPath}/course/${courseType}/${courseId}`);
            }
        },
        // 判断用户是否购买课程
        judgeCourse(courseId, type, bl) {
            let userId = getUserId();
            return new Promise(reslove => {
                this.$showLoading();
                if (!/^(courseTypeList|courseList|courseVip188)$/.test(this.$route.name || '')) {
                    this.$hideLoading();
                    reslove(false);
                }
                getCoursePermission(courseId, {
                    userId,
                    isSchedule: bl,
                    courseType: type
                }).then((res) => {
                    if (res.code == 200) {
                        this.$hideLoading();
                        let { permission, courseId, courseType } = res.data;
                        if (permission) {
                            // 购买了进入学习页
                            this.toLearn(courseId, courseType);
                        }
                        reslove(permission);
                    }
                    else {
                        reslove(false);
                    }
                });
            });
        },
        toDetail(item) {
            // 是否是线下训练营，如果不是就是OMO训练营
            if (item.isOperation || item.moduleType == 'operation') {
                if (appPort()) {
                    jumpModuleApp({
                        typeId: 'operation_detail',
                        dataId: item.tcId || item.lessonId
                    });
                }
                else {
                    location.assign(`${hostPath}/training/detail?id=${item.tcId || item.lessonId}`);
                }
                return;
            }
            this.judgeCourse(item.id, 'meeting', false).then(res => {
                if (!res) {
                    let url = `${hostPath}/learn/courseguide/train/${item.meetingId || item.lessonId || item.id}`;
                    if (appPort()) {
                        jumpModuleApp({
                            typeId: 'h5',
                            url: url
                        });
                    }
                    else {
                        // h5 进入导览页
                        this.$router.push({
                            path: `/courseguide/train/${item.meetingId || item.lessonId || item.id}`
                        });
                    }
                }
            });
        },
        fixedStatus: (item) => {
            if (item.targetType == 'album' && item.detailType == 'online') {
                return false;
            }
            if (item.isComing == '0' && item.moduleType == 'onlineOperation') {
                return false;
            }
            return true;
        }
    }
});
